import { useEffect, useRef } from "react";

const PALETTE = [
  "#ef4444", "#f97316", "#eab308", "#22c55e",
  "#3b82f6", "#8b5cf6", "#ec4899", "#06b6d4",
  "#64748b", "#0f172a", "#ffffff", "transparent",
];

export function NodeColorPicker({ x, y, currentColor, onSelect, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      data-testid="node-color-picker"
      style={{
        position: "fixed",
        left: Math.min(x, window.innerWidth - 200),
        top: Math.min(y, window.innerHeight - 120),
        zIndex: 9999,
        background: "white",
        border: "1px solid #e2e8f0",
        borderRadius: 10,
        boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <span style={{ fontSize: 11, color: "#94a3b8", fontFamily: "Manrope", fontWeight: 500, textTransform: "uppercase", letterSpacing: 1 }}>Node Color</span>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 6 }}>
        {PALETTE.map((color) => (
          <button
            key={color}
            data-testid={`color-swatch-${color}`}
            onClick={() => { onSelect(color); onClose?.(); }}
            title={color === "transparent" ? "Reset (default)" : color}
            style={{
              width: 24, height: 24, borderRadius: 6, cursor: "pointer",
              background: color === "transparent" ? "white" : color,
              border: color === currentColor ? "3px solid #0f172a" : "2px solid #e2e8f0",
              outline: "none",
              backgroundImage: color === "transparent" ? "repeating-linear-gradient(45deg, #e2e8f0 0, #e2e8f0 4px, white 0, white 8px)" : "none",
            }}
          />
        ))}
      </div>
    </div>
  );
}
